/**
 * Notice-receipts change bus (RD-NOTICES-V2).
 *
 * `NoticeReceiptsSync` fires this after ANY merge — hydration, the one-time
 * local-only upload, or a realtime row from another session — so every
 * mounted consumer (badges, counts, open modals) can re-read the local store
 * it cares about and reflect what just changed. Mirrors the existing
 * `estimateResponseSeenSignal` / `estimateResponseLiveSignal` shape: a bare
 * tick, no payload, so a listener can never be handed tenant data it should
 * not hold, and a stale listener leaks nothing.
 *
 * Module-level and NOT session-scoped by itself — every subscriber is a
 * component-scoped effect that unsubscribes on unmount, same discipline as
 * every other bus in this codebase.
 */

const listeners = new Set();

/** @returns {() => void} unsubscribe */
export function subscribeNoticeReceipts(listener) {
  if (typeof listener !== 'function') return () => {};
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

/** Fire one tick. Each listener runs in its own try/catch — one throwing
 *  listener must never break the others or the caller (a realtime flush). */
export function emitNoticeReceiptsChanged() {
  listeners.forEach((listener) => {
    try { listener(); } catch (_e) { /* never break the others */ }
  });
}

/** Test-only reset so a leaked listener cannot bleed between test files. */
export function __resetNoticeReceiptsBusListeners() {
  listeners.clear();
}
